import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { NotificationService } from './notification.service';
import { NotificationModel } from '../../../shared/models/notification.model';


@Component({
  selector: 'sc-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss']
})
export class NotificationComponent implements OnInit {
  public items = [
    {
      id: 'tabNoLeidas',
      label: 'No Leídas'
    },
    {
      id: 'tabLeidas',
      label: 'Leídas'
    }

  ];

  notifications = new Array<NotificationModel>();
  isLoading = false;
  @Output() onHandleCloseNotification: EventEmitter<any>;
  constructor(private notificationService: NotificationService) {
    this.onHandleCloseNotification = new EventEmitter();
  }

  ngOnInit() {

    this.isLoading = true;
    this.notificationService.getNotificationsByStatus(false).subscribe(
      (notificationsData: Array<NotificationModel>) => {
        this.notifications = notificationsData;
      }
    ).add(() => { this.isLoading = false; });
  }


  actionNotificationClick(notification: NotificationModel) {
    this.notificationService.setStatusNotifications(notification.id, !notification.isRead).subscribe(
      () => {
        this.notificationService.getNotificationsByStatus(notification.isRead).subscribe(
          (notificationsData: Array<NotificationModel>) => {
            this.notifications = notificationsData;
          }
        ).add(() => { this.isLoading = false; });
      }
    );
  }

  selectTab(selectedTab) {

    const status = (selectedTab.id === 'tabNoLeidas') ? false : true;
    this.isLoading = true;
    this.notificationService.getNotificationsByStatus(status).subscribe(
      (notificationsData: Array<NotificationModel>) => {
        this.notifications = notificationsData;
      }
    ).add(() => { this.isLoading = false; });
  }


  readAndClose(notification: NotificationModel) {

    if(!notification.isRead ){
       this.actionNotificationClick(notification);
    } 
    this.closeNotification();

  }

  closeNotification() {
    this.onHandleCloseNotification.emit();
  }

  getTitleCard(notification: NotificationModel) {
    return this.notificationService.getNotificationTitleCard(notification);
  }

  getActionsCard(notification: NotificationModel) {
    return this.notificationService.getNotificationTypeAction(notification);
  }

  getReason(notification: NotificationModel) {
    let reason;
    if (notification.notificationTypeId === 'CANCELACION_POLIZA' || notification.notificationTypeId === 'RECHAZO_UW') {
      reason = notification.data.CancellationReason;
    }
    return reason;
  }
  getTransitoryPaymentRequestCount(notification: NotificationModel): number {
    return notification.notificationTypeId === 'RECHAZO_PAGO' ? notification.data.transitoryRejectedCount : null;
  }
  getDefinitivePaymentRequestCount(notification: NotificationModel): number {
    return notification.notificationTypeId === 'RECHAZO_PAGO' ? notification.data.definitiveRejectedCount : null;
  }
}